import { useCallback } from 'react';
import debounce from 'lodash.debounce';

/**
 * Debounce the given function by the wait time (MS) provided
 * @param {function} fn - The function to be debounced
 * @param {number} wait - Wait time in milliseconds, defaults to 300
 * @param {array} deps - Dependency array, defaults to []
 * @param {object} opts - optional lodash.debounce options.
 * @returns The debounced function
 */
const useDebounce = (fn, wait = 300, deps = [], opts = {}) => {
  /* Disabled rule because this is safe usage, debounce won't ever go stale */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(debounce(fn, wait, opts), [...deps]);
};

export default useDebounce;
